import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { GsPlayerComponent } from 'gs-player/lib/gs-player.component';
import { MusicPlayerService } from '../../services/music-player.service';
import { GsPlayerService } from 'gs-player';

@Component({
  selector: 'app-music-player',
  templateUrl: './music-player.component.html',
  styleUrls: ['./music-player.component.scss']
})
export class MusicPlayerComponent implements OnInit, AfterViewInit {
  @ViewChild('wrapPlayer') public wrapPlayer: GsPlayerComponent;

  constructor(
    public gsPlayer: GsPlayerService,
    private cd: ChangeDetectorRef,
    public musicPlayerService: MusicPlayerService
  ) {}
  ngAfterViewInit(): void {
    this.musicPlayerService.wrapPlayer = this.wrapPlayer;
  }
  ngOnInit(): void {
    this.gsPlayer.getState().subscribe((state) => {
      this.cd.detectChanges();
    });
  }
}
